<template>
    <div class="q-answer">
        <pv-input-number
                style="width: 100%; max-width: 400px"
                mode="decimal"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                :locale="'pl'"
                v-model="answerObj.numberValue" />
    </div>
</template>

<script>

    import InputNumber from 'primevue/inputnumber';

    export default {
        props: ['answer'],
        emits: ['changeValue'],

        data() {
            return {
                answerObj: null,
                createdData: false
            }
        },


        components: {
            'pv-input-number': InputNumber
        },
        created() {
            this.answerObj = this.answer;
        },

        watch: {

            answerObj: {
                handler() {
                    if (this.createdData) {
                        this.$emit('changeValue', this.answerObj);
                    } else {
                        this.createdData = true;
                    }
                },
                deep: true
            }
        }
    }
</script>